"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileVisibilityOptions = exports.FileVisibilityOptionNames = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _FileVisibilityOption, _FileVisibilityOption2;

var VISIBLE_TO_ALL = 'VISIBLE_TO_ALL';
var VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES = 'VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES';
var HIDDEN_FROM_ALL = 'HIDDEN_FROM_ALL';
var FileVisibilityOptionNames = (_FileVisibilityOption = {}, (0, _defineProperty2.default)(_FileVisibilityOption, VISIBLE_TO_ALL, VISIBLE_TO_ALL), (0, _defineProperty2.default)(_FileVisibilityOption, VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES, VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES), (0, _defineProperty2.default)(_FileVisibilityOption, HIDDEN_FROM_ALL, HIDDEN_FROM_ALL), _FileVisibilityOption);
exports.FileVisibilityOptionNames = FileVisibilityOptionNames;
var FileVisibilityOptions = (_FileVisibilityOption2 = {}, (0, _defineProperty2.default)(_FileVisibilityOption2, VISIBLE_TO_ALL, {
  allow_anonymous_access: true,
  is_indexable: true
}), (0, _defineProperty2.default)(_FileVisibilityOption2, VISIBLE_TO_USERS_HIDDEN_FROM_SEARCH_ENGINES, {
  allow_anonymous_access: true,
  is_indexable: false
}), (0, _defineProperty2.default)(_FileVisibilityOption2, HIDDEN_FROM_ALL, {
  allow_anonymous_access: false,
  is_indexable: false
}), _FileVisibilityOption2);
exports.FileVisibilityOptions = FileVisibilityOptions;